import { Injectable } from '@angular/core';
import { PageService } from '../models/page.service';
var RoleGuard = /** @class */ (function () {
    function RoleGuard(service) {
        this.service = service;
    }
    RoleGuard.prototype.canActivate = function (route, state) {
        var _this = this;
        var segments = route.url;
        var flow = '';
        var page = '';
        if (segments.length > 0) {
            flow = segments[0].path;
        }
        if (segments.length > 1) {
            page = segments[1].path;
        }
        var handler = this.handler(route);
        return new Promise(function (resolve) {
            _this.service.getPage(flow, page).toPromise().then(function (data) {
                if (handler(data)) {
                    resolve(true);
                }
                else {
                    resolve(false);
                }
            }).catch(function (reason) {
                console.error(reason);
                resolve(false);
            });
        });
    };
    RoleGuard.prototype.handler = function (route) {
        return function (data) {
            if (data) {
                var new_data = {};
                Object.assign(new_data, route.data);
                new_data['meta'] = data;
                route.data = new_data;
                return true;
            }
            else {
                return false;
            }
        };
    };
    RoleGuard.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    RoleGuard.ctorParameters = function () { return [
        { type: PageService }
    ]; };
    return RoleGuard;
}());
export { RoleGuard };
//# sourceMappingURL=role.guard.js.map